const Grocery = () => {
  return (
    <h1 className="text-3xl font-bold underline">
      {""}Our grocery online store and many items
    </h1>
  );
};

export default Grocery;
